import React, { FC } from 'react';
import CirLogo from 'app/assets/images/cirLogo.png';

export const Logo: FC = () => {
  return (
    <div className="logo">
      <img src={CirLogo} alt="Logo" />
    </div>
  );
};
